import axios from 'axios'

const request = axios.create({
  // baseURL: 'http://192.168.1.65:8000/api/v1/',
  baseURL: 'https://btmswaterbg.sdbina.com/api/v1/',
  timeout: 120000
})
export default request
